let pageConfig = {}

pageConfig.listColumns = [
  {
    label: '活动订单编号',
    props: 'activityOrderNo',
    minWidth: 250,
    formatter: (row) => {
      const rowStr = JSON.stringify(row).replace(/"/g, '&quot;');
      return `<span style="color: #409EFF; cursor: pointer;" onclick="window.handleActivityOrderNoClick && window.handleActivityOrderNoClick('${rowStr}')">${row.activityOrderNo}</span>`;
    }
  },
  { label: '用户姓名', props: 'name', minWidth: 120 },
  { label: '用户手机号', props: 'mobile', minWidth: 130 },
  { label: '购买名称', props: 'purchaseName', minWidth: 120 },
  {
    label: '订单状态',
    props: 'orderStatus',
    minWidth: 200,
    formatter: (row) => {
      const statusMap = {
        'INIT': '初始化',
        'COMMIT': '已报名',
        'TO_CONTACT': '待联系',
        'TO_INSTALL': '待安装',
        'TO_ACTIVATION': '待激活',
        'IN_USE': '使用中',
        'SWAPPING': '换桩中',
        'PAUSE': '暂停使用',
        'TO_COMPLIANCE': '待守约',
        'IN_OVERDUE': '已逾期',
        'IN_DEFAULTED': '已违约',
        'IN_CANCELING': '解约申请中',
        'IN_CANCELLED_BUYOUT': '已解约(买断)',
        'IN_CANCELLED_REFUNDED': '已解约(退款)',
        'IN_EXPIRED': '已解约(到期)'
      }
      return statusMap[row.orderStatus] || row.orderStatus || '--'
    }
  },
  {
    label: '流量服务状态',
    props: 'actualAmountStatus',
    minWidth: 180,
    formatter: (row) => {
      const statusMap = {
        'TO_EXPRIRED': '即将到期',
        'EXPIRED': '已过期',
        'TO_ACTIVE': '待激活',
        'ACTIVE': '正常',
        'IN_ACTIVE': '正常',
        'EXPIRING_SOON': '即将到期',
        'CANCELLED': '已解约（买断）',
        'TO_RENEWED': '待续费',
      }
      return statusMap[row.actualAmountStatus] || row.actualAmountStatus || '--'
    }
  },
  {
    label: '商家代扣状态',
    props: 'holdAgreement',
    minWidth: 120,
    formatter: (row) => {
      if (row.holdAgreement === 'Y') return '已签约';
      if (row.holdAgreement === 'N') return '未签约';
      return row.holdAgreement || '--';
    }
  },
  { label: '客服联系状态', props: 'activityOrderContractStatusName', minWidth: 180 },
  { label: '安装状态', props: 'activityOrderInstallStatusName', minWidth: 180 },
  { label: '不安装/不签约原因', props: 'installFailReason', minWidth: 180 },
  { label: '产品编号', props: 'pileCode', minWidth: 180 },
  { label: '充电桩资产编号', props: 'pileAssetCode', minWidth: 180 },
  { label: '报名创建时间', props: 'createdWhen', minWidth: 180 },
  { label: '关联主服订单号', props: 'pileInstallOrderNo', minWidth: 180 },
  { label: '充电桩安装完成时间', props: 'pileInstallCompletedTime', minWidth: 180 },
  { label: '充电桩使用状态', props: 'activateStatusName', minWidth: 180 },
  { label: '充电桩绑定激活时间', props: 'bindTime', minWidth: 180 },
  { label: '激活切换操作人', props: 'activateOperatePer', minWidth: 180 },
  { label: '激活切换操作时间', props: 'activateOperateWhen', minWidth: 180 },
  { label: '流量服务当前开始时间', props: 'actualAmountStartTime', minWidth: 180 },
  { label: '流量服务当前到期时间', props: 'actualAmountEndTime', minWidth: 180 },
  { label: '流量服务剩余天数', props: 'actualAmountDaysRemaining', minWidth: 120 },
  { label: '流量服务累计使用月数', props: 'actualAmountCumulativeMonths', minWidth: 120 },
  { label: '流量服务累计支付（元）', props: 'actualAmountTotal', minWidth: 120 },
  { label: '解约申请时间', props: 'cancelRequestTime', minWidth: 180 },
  { label: '解约完成时间', props: 'cancelFinishTime', minWidth: 180 },
  { label: '解约原因', props: 'cancelReason', minWidth: 180 },
  { label: '解约应付金额（元）', props: 'cancelPayableAmount', minWidth: 180 },
  { label: '解约应退金额（元）', props: 'cancelAmount', minWidth: 180 },
  { label: '是否买断回退', props: 'buyoutOrNot', minWidth: 180 },
  { label: '回退金额（元）', props: 'rebackedAmount', minWidth: 180 },
  { label: '解约退款操作人', props: 'rebackedAmountOperatePer', minWidth: 180 },
  { label: '解约退款操作时间', props: 'refundOperateTime', minWidth: 180 },
  { label: '解约退款完成时间', props: 'refundFinishTime', minWidth: 180 },
  { label: '省', props: 'province', minWidth: 180 },
  { label: '市', props: 'city', minWidth: 180 },
  { label: '区', props: 'area', minWidth: 180 },
  { label: '详细地址', props: 'address', minWidth: 180 },
]

pageConfig.listBreadCrumb = [
  { type: 'title', name: '首页' },
  { type: 'title', name: '订单管理' },
  { type: 'title', name: '家庭充电订单列表' },
]

pageConfig.tableConfig = {
  showSelection: true,
  showIndex: false,
}

pageConfig.pagination = {
  current: 1,
  total: 0,
  pageSize: 10,
  pageSizes: [10, 20, 50, 100],
}

export default pageConfig

